import script from "./ProfitRanking.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfitRanking.vue?vue&type=script&setup=true&lang=js"

import "./ProfitRanking.vue?vue&type=style&index=0&id=a3042b94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3042b94"]])

export default __exports__